import * as types from './mutation-types'
import store from '../store'

import {staleCacheConfig} from 'stale-cache'

const staleCache = staleCacheConfig({execute: req => axios(req)})

export const setFilters = ({commit}, filters) => {
    commit(types.SET_FILTERS, {filters: filters})
}

export const resetModels = ({commit}) => {
    commit(types.RESET_MODELS)
}

export const loadModels = ({commit}, data) => {
    axios.post('/get-models', data).then((response) => {
        if (response.data.length === 0) {
            commit(types.SET_SEARCHENDED, true)
        } else {
            commit(types.SET_MODELS, {models: response.data, skip: data.skip})
        }
    })
}

export const loadFavoritesIds = ({commit}) => {
    commit(types.SET_FAVORITES_IDS)
}

export const loadFavorites = ({commit}, favoritesIds) => {
    const request = {url: '/favorites/get', params: {ids: favoritesIds}, method: "POST"}
    staleCache(request)
        .then(response => {
            if (response.data) {
                commit(types.SET_FAVORITES, response.data)
            }
            return response.fresh()
        })
        .then(response => {
            commit(types.SET_FAVORITES, response.data)
        })
}

export const getApplication = ({commit}, applicationId) => {
    axios.get('/get-application/' + applicationId).then((response) => {
        commit(types.SET_APPLICATION, response.data)
        commit(types.SET_NOOF_HEARTS)
    })
}
export const getProposal = ({commit}, data) => {
    axios.get('/get-application/' + data.applicationId).then((response) => {
        commit(types.SET_APPLICATION, response.data)
        commit(types.SET_NOOF_HEARTS)
        store.dispatch('syncModels', data.proposalId);
    })
}
//
// export const setHearts = ({commit}) => {
//     commit(types.SET_HEARTS)
// }

// export const loadApplication = ({commit}, applicationId) => {
//     commit(types.SET_APPLICATION, applicationId)
// }
export const setHeart = ({commit}, data) => {
    commit(types.SET_HEART, data)
    commit(types.SET_NOOF_HEARTS)
}

export const syncModels = ({state}, proposalId) => {
    let proposedModels = state.application.roles[proposalId].models
    let ids = _.map(proposedModels, 'ID_Model')
    axios.post('/sync-models', {'model_ids': ids}).then((response) => {
        document.querySelectorAll('.loader')[0].classList.add('hidden')
    })
}

// export const loadProposal = ({commit}, proposalId) => {
//     axios.get('/get-proposal/' + proposalId).then((response) => {
//         commit(types.SET_APPLICATION, response.data)
//     })
// }
//
// export const loadProposalFavorites = ({commit}, proposalId) => {
//     axios.get('/get-proposal-favorites/' + proposalId).then((response) => {
//         commit(types.SET_MODELS, {models: response.data, skip: data.skip})
//     })
// }

export const setMode = ({commit}, mode) => {
    commit(types.SET_MODE, mode)
}

export const setProject = ({commit}, project) => {
    commit(types.SET_PROJECT, project)
}

export const setFavorites = ({commit}, data) => {
    commit(types.SET_FAVORITES, data)
}

export const setApplicationFavorites = ({commit}, data) => {
    commit(types.SET_APPLICATION_FAVORITES, data)
}

export const showConfirmDeleteFavorite = ({commit}, value) => {
    commit(types.SHOW_CONFIRM_DELETE_FAVORITE, value)
}

export const setConfirmDeleteFavorite = ({commit}, value) => {
    commit(types.SET_CONFIRM_DELETE_FAVORITE, value)
}

export const setDeleteFavoriteId = ({commit}, value) => {
    commit(types.SET_DELETE_FAVORITE_ID, value)
}

export const forceHidePreview = ({commit}) => {
    commit(types.FORCE_HIDE_PREVIEW)
}

export const forceReloadFavorites = ({commit}) => {
    commit(types.FORCE_RELOAD_FAVORITES)
}

export const deleteAllFavorites = ({commit}) => {
    commit(types.DELETE_ALL_FAVORITES)
}

export const setApplicationId = ({commit}, id) => {
    commit(types.SET_APPLICATION_ID, id)
}

export const setProposalId = ({commit}, id) => {
    commit(types.SET_PROPOSAL_ID, id)
}
